import type {AiChatPromptBoxOptions} from '@Components/ai-chat-window/ai-chat-window.types';
import {AiChatPromptBoxFooterButton} from '@Components/ai-chat-window/ai-chat-window.types';
import type {AiPromptBoxAttachments, PromptAttachment} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';
import {getDefaultAttachments} from '@Components/ai-prompt-box/libraries/ai-prompt-box-attachment.library';

export function getStartingPromptBoxAttachments(initialAttachments: PromptAttachment[] | undefined, promptBoxOptions: AiChatPromptBoxOptions | undefined): AiPromptBoxAttachments {
  const defaultAttachments = getDefaultAttachments(initialAttachments);

  return {
    ...defaultAttachments,
    dropdown: promptBoxOptions?.attachmentDropdown ?? defaultAttachments.dropdown,
    acceptsDocuments: promptBoxOptions?.acceptsDocuments ?? true,
  };
}

export function getPromptBoxPlaceholder(promptBoxOptions: AiChatPromptBoxOptions | undefined, ownPlaceholderKey: string): string {
  return promptBoxOptions?.placeholder ?? window.i18next.t(ownPlaceholderKey);
}

export function getShownFooterButtons(allowedButtons: AiChatPromptBoxFooterButton[] | undefined): AiChatPromptBoxFooterButton[] {
  const everyButton = Object.values(AiChatPromptBoxFooterButton);

  if (!allowedButtons) {
    return everyButton;
  }

  return everyButton.filter((button) => allowedButtons.includes(button));
}
